import { EntityId, PaginationRequest } from '../common';

export interface LegalEntityRequest extends PaginationRequest {
  legalEntityIds?: EntityId[];
}
